<template>
  <section id="features" class="bg-light">
    <div class="section-inner">
      <div class="container">
      <h2>Features</h2>
        <div class="row vertical-center">
          <div :class="{ 'scrolled' : scrolled }" ref="feature" class="col-xs-12 col-lg-7 copy-wrap">
            <slot name="content"></slot>
          </div>
          <div class="img-container hidden-xs hidden-sm col-lg-5">
            <slot name="img"></slot>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'features',
  data () {
    return {
      scrolled: false
    }
  },
  created: function () {
    window.addEventListener('scroll', this.inView)
  },
  methods: {
    inView: function () {
      const el = this.$refs.feature
      const top = el.getBoundingClientRect().top
      const bottom = el.getBoundingClientRect().bottom

      if (!this.scrolled) {
        if (top < window.innerHeight && bottom >= 0) {
          this.scrolled = true
          window.removeEventListener('scroll', this.inView)
        }
      }
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.inView)
  }
}
</script>
<style scoped lang="stylus" src="./features.styl">
